import { useMutation, useQueryClient } from "@tanstack/react-query";

import { BASE_QUERY_KEY } from "../../utils/constants";
import { QUERY_KEY as GET_ACCESS_REQUEST_QUERY_KEY } from "../access-requests/use-get-access-request";

import useAccessGroupsApi from "./use-access-groups-api";

export default function useResetAccessGroupCredentials(id: string) {
  const api = useAccessGroupsApi();
  const queryClient = useQueryClient();

  const {
    mutate: resetAccessGroupCredentials,
    mutateAsync: resetAccessGroupCredentialsAsync,
    ...rest
  } = useMutation(
    async () => {
      const res = await api.resetAccessGroupCredentials({ id });

      return res;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [BASE_QUERY_KEY, GET_ACCESS_REQUEST_QUERY_KEY],
        });
      },
    },
  );

  return {
    resetAccessGroupCredentials,
    resetAccessGroupCredentialsAsync,
    ...rest,
  };
}
